import { render, staticRenderFns } from "./device.vue?vue&type=template&id=3cdfa2ff&scoped=true"
import script from "./device.vue?vue&type=script&lang=js"
export * from "./device.vue?vue&type=script&lang=js"
import style0 from "./device.vue?vue&type=style&index=0&id=3cdfa2ff&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cdfa2ff",
  null
  
)

export default component.exports